export const THEME_COLORS = {
    primary: "#010101",
    accent: "#71b5dc",
    secondary: "#7f8c8d",
    warning: "#dc8f38",
    discount: "#dab99a",

    white: "#ffffff",
    black: "#010101",

    greyLight: "#e0e0e0",
    greyMedium: "#474747",
    greyDark: "#999999",
    greyExtraDark: "#666666",

    // de estado
    success: "#4caf50",
    error: "#d32f2f",
    info: "#2196f3",

    overlay: {
        dark: "#01010133",
        darkStrong: "#0101014D",
        light: "#01010199",
        veryLight: "#01010108",
    },

    text: {
        primary: "#010101",
        secondary: "#7f8c8d",
        disabled: "#cccccc",
        light: "rgba(0, 0, 0, 0.70)",
        lighter: "rgba(0, 0, 0, 0.60)",
    },

    background: {
        paper: "#ffffff",
        default: "#ffffff",
    },
} as const;

export type ThemeColor = typeof THEME_COLORS;
